/**
 * 根据产品代码获取产品数据
 */
export function useProductsByCodes(codes) {
  // Support both plain arrays and refs/computed
  const arr = Array.isArray(codes) ? codes : (codes?.value || [])
  return useAsyncData(
    `products-${arr.join(',')}`,
    async () => {
      try {
        const resp = await $fetch('/api/products-by-codes', {
          params: { codes: arr.join(',') },
        })
        return resp?.data || []
      } catch {
        return []
      }
    },
    { default: () => [] }
  )
}
